import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader';
import * as THREE from 'three';
import SceneInit from './SceneInit'; // Assuming you have a SceneInit component
import Swal from 'sweetalert2';
import { baseUrl, baseimgUrl, userLocation, ipAddress, userName } from '../Univ.js';

function ThreedImg(props) {
  const { con_id } = useParams();
  const { appt_id } = useParams();
  const [markedPoints, setMarkedPoints] = useState([]);
  const [coordinatesWithText, setCoordinatesWithText] = useState([]);
  const [conData, setConData] = useState({});

  useEffect(() => {
    fetchConData();
  }, []);

function fetchConData() {
  axios
    .get(baseUrl + "view-consultform/" + appt_id)
    .then((response) => {
      setConData(response.data);
      // Access the coordinates JSON string correctly
      const coordinatesJsonString = response.data[0].coordinates;
      const textmap = response.data[0].textmap;
      try {
        // Parse the coordinates JSON string
        const parsedCoordinates = JSON.parse(coordinatesJsonString);
        // Split the textmap into an array
        const textArray = textmap.split(",");
        // Create an array of objects with coordinates and text
        const coordinatesWithText = parsedCoordinates.map((coord, index) => ({
          coordinate: coord,
          text: textArray[index] || "", // Use empty string if text is not available
        }));
        // Set the state with the coordinates and text data
        setCoordinatesWithText(coordinatesWithText);

      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    })
    .catch((error) => {
      console.log("Fetch Error:", error);
    });
}
  const handleTextChange = (coordinate, newText) => {
    setCoordinatesWithText((prevCoordinates) =>
      prevCoordinates.map((item) =>
        item.coordinate === coordinate ? { ...item, text: newText } : item
      )
    );
  };

  useEffect(() => {
    const test = new SceneInit('myThreeJsCanvas');
    test.initialize();
    test.animate();

    let loadedModel;
    const gltfLoader = new GLTFLoader();
    gltfLoader.load('/scene.gltf', (gltfScene) => {
      loadedModel = gltfScene;
      loadedModel.scene.scale.set(100, 100, 100);
      test.scene.add(gltfScene.scene);
    });

    const canvas = test.renderer.domElement;
    const raycaster = new THREE.Raycaster();
    const mouse = new THREE.Vector2();

    const handleMouseClick = (event) => {
      const rect = canvas.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      const y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
      mouse.set(x, y);
      raycaster.setFromCamera(mouse, test.camera);
      const intersects = raycaster.intersectObject(loadedModel.scene, true);
      if (intersects.length > 0) {
        const intersectionPoint = intersects[0].point.clone();
        const marker = new THREE.Mesh(
          new THREE.SphereGeometry(0.03, 5, 5),
          new THREE.MeshBasicMaterial({ color: 0x800080 })
        );
        marker.position.copy(intersectionPoint);
        test.scene.add(marker);
        const newMarkedPoints = [...markedPoints, intersectionPoint];
        setMarkedPoints(newMarkedPoints);
        setCoordinatesWithText((prevCoordinates) => [
          ...prevCoordinates,
          { coordinate: intersectionPoint, text: '' },
        ]);
      }
    };

    const clearMarkedPoints = () => {
      const markersToRemove = test.scene.children.filter(
        (child) => child.type === 'Mesh'
      );
      markersToRemove.forEach((marker) => test.scene.remove(marker));
      setMarkedPoints([]);
      setCoordinatesWithText([]);
    };

    document.querySelector('#clear').addEventListener('click', clearMarkedPoints);
    canvas.addEventListener('click', handleMouseClick);

    return () => {
      canvas.removeEventListener('click', handleMouseClick);
    };
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();
    const formData = new FormData();
    const coordinates = coordinatesWithText.map((item) => ({
      x: item.coordinate.x,
      y: item.coordinate.y,
      z: item.coordinate.z,
    }));
    const textmap = coordinatesWithText.map((item) => item.text);

    formData.append('coordinates', JSON.stringify(coordinates));
    formData.append('textmap', textmap.join(',')); // Join text values with a comma
    formData.append('ip_add', ipAddress);
    formData.append('location', userLocation);

    axios
      .put(baseUrl + 'edit-case/' + con_id + '/', formData)
      .then((response) => {
        if (response.status == 200 || response.status == 201) {
          Swal.fire({
            title: 'Details Updated.',
            icon: 'success',
            timer: 5000,
            showConfirmButton: false,
          });

          setTimeout(() => {
            window.location.href = '/cons-detail/' + appt_id;
          }, 3000);
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire('Error!', 'Failed to update', 'error');
      });
  };

  return (
    <section className="container mt-4">
      <div className="threedimg-container">
        <canvas id="myThreeJsCanvas" />
        <div className="controls-container">
          <button id="clear" className="btn btn-primary">
            Clear
          </button>
          <button type="button" onClick={submitHandler} className="btn btn-success ms-3">
            Submit
          </button>
        </div>
        <div className="coordinates-container">
          <h3>Coordinates with Text:</h3>
          {coordinatesWithText.map((item, index) => (
            <div key={index} className="coordinate-input">
              <span>
                (X: {item.coordinate.x.toFixed(2)}, Y: {item.coordinate.y.toFixed(2)}, Z:{' '}
                {item.coordinate.z.toFixed(2)}) -{' '}
              </span>
              <input
                type="text"
                value={item.text}
                onChange={(event) => handleTextChange(item.coordinate, event.target.value)}
                placeholder="Enter text..."
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ThreedImg;
